import * as React from 'react';

import { DataTable, Table } from '../../components/common';
import { IconButton } from '../../components/buttons';
import { IconEdit } from '../../components/icons';
import Utils from '../../common/utils';

interface Props {
	history: any;
	isLoading: boolean;
	softDeclinedCustomers: SoftDeclinedUserDetailsDto[];
	onAddNotesClick: (e: any, userId: string) => void;
	setRedirectFromAdjudication: (redirect: boolean) => void;
}
interface State {
	page: number;
}

class AdjudicationList extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			page: 0
		};
	}

	onPageChange = (pageIndex: number) => {
		this.setState({ page: pageIndex });
	}

	render() {
		const { ...props } = this.props;
		return (
			<div className="content-set">
				<DataTable
					TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
					columns={[
						{
							accessor: 'id',
							show: false
						},
						{
							Header: 'Full Name',
							accessor: 'fullName'
						},
						{
							Header: 'Policy Number',
							accessor: 'customerPolicy.number'
						},
						{
							Header: 'Email',
							accessor: 'email',
							Cell: (rowInfo: any) => {
								if (rowInfo.original.email) {
									return <a href={`mailto:${rowInfo.original.email}`} onClick={e => e.stopPropagation()}>{rowInfo.value}</a>;
								} else {
									return rowInfo.value;
								}
							}
						},
						{
							Header: 'Created Date',
							accessor: 'createdDate',
							Cell: (row: any) => Utils.formatDateAsUTC(row.value)
						},
						{
							Header: 'Status',
							accessor: 'customerPolicy.adjudicationStatusId',
							Cell: (row: any) => Utils.getPickListItemDescription(row.value)
						},
						{
							Header: 'Actions',
							className: 'p-0 td-actions',
							width: 120,
							Cell: (rowInfo: any) => {
								return (
									<span>
									<IconButton
										title="Add Notes"
										className="btn-icon-secondary btn-icon-td"
										onClick={(e: any) => {
												props.setRedirectFromAdjudication(true);
												props.onAddNotesClick(e, rowInfo.row.id);
											}
										}
									>
										<IconEdit />
									</IconButton>	
									</span>
								);
							}
						}
					]}
					data={props.softDeclinedCustomers}
					loading={props.isLoading}
					getTrProps={(state: any, rowInfo: any, column: any) => {
						return {
							className: 'tr interactive',
							onClick: () => {
								props.setRedirectFromAdjudication(true);
								return props.history.push(`/admin/prospects/${rowInfo.original.id}/details`);
							}
						};
					}}
					noDataText="No customers found"
					onPageChange={this.onPageChange}
					page={this.state.page}
				/>
			</div>
		);
	}

}

export default AdjudicationList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/adjudication/AdjudicationList.tsx